export const LINKS = {
  SUPPORT: "/support",
};
